import type { WorkspaceTab } from 'src/models/workspaceTabs';

export interface WorkspaceTabsState {
	activeTabId: null | string;
	lastActiveModuleTabId: null | string;
	pendingDetailHandovers: string[];
	tabs: WorkspaceTab[];
}

export const createWorkspaceTabsState = (): WorkspaceTabsState => ({
	activeTabId: null,
	lastActiveModuleTabId: null,
	pendingDetailHandovers: [],
	tabs: [],
});
